/**
 * Authorization Roles
 */
const authRoles = {
  superadmin: ['ROLE_SUPER_ADMIN'],
  admin: ['admin'],
  staff: ['admin', 'staff'],
  user: ['admin', 'staff', 'user'],
  ROLE_SALON: [
    'ROLE_SALON_LIST',
    'ROLE_SALON_ADD',
    'ROLE_SALON_SHOW',
    'ROLE_SALON_EDIT',
    'ROLE_SALON_DELETE',
    'ROLE_USER'
  ],
  ROLE_JOB: [
    'ROLE_JOB_LIST',
    'ROLE_JOB_ADD',
    'ROLE_JOB_SHOW',
    'ROLE_JOB_EDIT',
    'ROLE_JOB_DELETE',
    'ROLE_USER'
  ],
  ROLE_SERVICE: [
    'ROLE_SERVICE_LIST',
    'ROLE_SERVICE_ADD',
    'ROLE_SERVICE_SHOW',
    'ROLE_SERVICE_EDIT',
    'ROLE_SERVICE_DELETE',
    'ROLE_USER'
  ],
  ROLE_SERVICEMANAGER: [
    'ROLE_SERVICEMANAGER_LIST',
    'ROLE_SERVICEMANAGER_ADD',
    'ROLE_SERVICEMANAGER_SHOW',
    'ROLE_SERVICEMANAGER_EDIT',
    'ROLE_SERVICEMANAGER_DELETE',
    'ROLE_USER'
  ],
  ROLE_NATIONAL_OPERATION: [
    'ROLE_NATIONAL_OPERATION_LIST',
    'ROLE_NATIONAL_OPERATION_ADD',
    'ROLE_NATIONAL_OPERATION_SHOW',
    'ROLE_NATIONAL_OPERATION_EDIT',
    'ROLE_NATIONAL_OPERATION_DELETE',
    'ROLE_USER'
  ],
  ROLE_OPERATIONMANAGER: [
    'ROLE_OPERATIONMANAGER_LIST',
    'ROLE_OPERATIONMANAGER_ADD',
    'ROLE_OPERATIONMANAGER_SHOW',
    'ROLE_OPERATIONMANAGER_EDIT,ROLE_OPERATIONMANAGER_DELETE',
    'ROLE_USER'
  ],
  ROLE_NATIONAL_PRICE: [
    'ROLE_NATIONAL_PRICE_LIST',
    'ROLE_NATIONAL_PRICE_ADD',
    'ROLE_NATIONAL_PRICE_SHOW',
    'ROLE_NATIONAL_PRICE_EDIT',
    'ROLE_NATIONAL_PRICE_DELETE',
    'ROLE_USER'
  ],
  ROLE_CONTACT: [
    'ROLE_CONTACT_LIST',
    'ROLE_CONTACT_ADD',
    'ROLE_CONTACT_SHOW',
    'ROLE_CONTACT_EDIT',
    'ROLE_CONTACT_DELETE',
    'ROLE_CONTACT_IMPORT',
    'ROLE_USER'
  ],
  ROLE_ORIGIN: [
    'ROLE_ORIGIN_LIST',
    'ROLE_ORIGIN_ADD',
    'ROLE_ORIGIN_SHOW',
    'ROLE_ORIGIN_EDIT',
    'ROLE_ORIGIN_DELETE',
    'ROLE_USER'
  ],
  ROLE_MANAGER: [
    'ROLE_MANAGER_LIST',
    'ROLE_MANAGER_ADD',
    'ROLE_MANAGER_SHOW',
    'ROLE_MANAGER_EDIT',
    'ROLE_MANAGER_DELETE',
    'ROLE_USER'
  ],
  ROLE_USERMANAGER: [
    'ROLE_USERMANAGER_LIST',
    'ROLE_USERMANAGER_ADD',
    'ROLE_USERMANAGER_SHOW',
    'ROLE_USERMANAGER_EDIT',
    'ROLE_USERMANAGER_DELETE',
    'ROLE_USER'
  ],
  ROLE_SALONMANAGER: [
    'ROLE_SALONMANAGER_LIST',
    'ROLE_SALONMANAGER_ADD',
    'ROLE_SALONMANAGER_SHOW',
    'ROLE_SALONMANAGER_EDIT',
    'ROLE_SALONMANAGER_DELETE',
    'ROLE_USER'
  ],
  ROLE_GROUP: [
    'ROLE_GROUP_LIST',
    'ROLE_GROUP_ADD',
    'ROLE_GROUP_SHOW',
    'ROLE_GROUP_EDIT',
    'ROLE_GROUP_DELETE',
    'ROLE_USER'
  ],
  ROLE_COLLABORATOR_MANAGERS: [
    'ROLE_COLLABORATOR_MANAGERS_ALL',
    'ROLE_COLLABORATOR_MANAGERS_LIST',
    'ROLE_COLLABORATOR_MANAGERS_SHOW',
    'ROLE_COLLABORATOR_MANAGERS_ADD',
    'ROLE_COLLABORATOR_MANAGERS_EDIT',
    'ROLE_COLLABORATOR_MANAGERS_DELETE'
  ],
  ROLE_FEEDBACK: [
    'ROLE_FEEDBACK_LIST',
    'ROLE_FEEDBACK_ADD',
    'ROLE_FEEDBACK_SHOW',
    'ROLE_FEEDBACK_EDIT',
    'ROLE_FEEDBACK_DELETE',
    'ROLE_USER'
  ],
  ROLE_COMMENT: ['ROLE_COMMENT_LIST', 'ROLE_COMMENT_SHOW', 'ROLE_USER'],
  ROLE_MESSAGE: [
    'ROLE_MESSAGE_LIST',
    'ROLE_MESSAGE_ADD',
    'ROLE_MESSAGE_SHOW',
    'ROLE_MESSAGE_EDIT',
    'ROLE_MESSAGE_DELETE',
    'ROLE_USER'
  ],
  ROLE_HEADER: [
    'ROLE_HEADER_LIST',
    'ROLE_HEADER_ADD',
    'ROLE_HEADER_SHOW',
    'ROLE_HEADER_EDIT',
    'ROLE_HEADER_DELETE',
    'ROLE_USER'
  ],
  ROLE_NEWS: [
    'ROLE_NEWS_LIST',
    'ROLE_NEWS_ADD',
    'ROLE_NEWS_SHOW',
    'ROLE_NEWS_EDIT',
    'ROLE_NEWS_DELETE',
    'ROLE_USER'
  ],
  ROLE_AQUITEM: ['ROLE_AQUITEM_SHOW', 'ROLE_USER'],
  ROLE_INTRANET: ['ROLE_INTRANET_SHOW', 'ROLE_USER'],
  ROLE_CARTE: ['ROLE_CARTE_SHOW', 'ROLE_USER'],
  ROLE_MAJSITE: ['ROLE_MAJSITE_SHOW', 'ROLE_USER'],
  ROLE_SUCCURSALE: ['ROLE_SUCCURSALE_EDIT', 'ROLE_USER'],
  ROLE_FRANCHISE: ['ROLE_FRANCHISE_EDIT', 'ROLE_USER'],
  ROLE_ETIQUETTE: ['ROLE_ETIQUETTE_SHOW', 'ROLE_USER'],
  ROLE_PRESSE: ['ROLE_PRESSE_SHOW', 'ROLE_USER'],
  ROLE_GOOGLE: ['ROLE_GOOGLE_SHOW', 'ROLE_USER'],
  ROLE_DASHBOARD: ['ROLE_DASHBOARD_SHOW', 'ROLE_USER'],
  ROLE_DASHBOARD_SALON: ['ROLE_DASHBOARD_SALON_SHOW', 'ROLE_USER'],
  ROLE_DASHBOARD_NEWS: ['ROLE_DASHBOARD_NEWS_SHOW', 'ROLE_USER'],
  ROLE_DASHBOARD_HELP: ['ROLE_DASHBOARD_HELP_SHOW', 'ROLE_USER'],
  ROLE_ADMIN: [
    'ROLE_MANAGER',
    'ROLE_JOB',
    'ROLE_CONTACT',
    'ROLE_GROUP',
    'ROLE_ORIGIN',
    'ROLE_FEEDBACK',
    'ROLE_COMMENT',
    'ROLE_SALON',
    'ROLE_NATIONAL_OPERATION',
    'ROLE_OPERATIONMANAGER',
    'ROLE_USER',
    'ROLE_USERMANAGER',
    'ROLE_SALONMANAGER',
    'ROLE_NATIONAL_PRICE',
    'ROLE_HEADER',
    'ROLE_DASHBOARD_HEADER',
    'ROLE_MESSAGE',
    'ROLE_DASHBOARD_MESSAGE',
    'ROLE_NEWS',
    'ROLE_DASHBOARD_HELP',
    'ROLE_DASHBOARD_NEWS',
    'ROLE_DASHBOARD',
    'ROLE_AQUITEM',
    'ROLE_SERVICE',
    'ROLE_SERVICEMANAGER',
    'ROLE_INTRANET',
    'ROLE_ETIQUETTE',
    'ROLE_CARTE',
    'ROLE_GOOGLE',
    'ROLE_PRESSE',
    'ROLE_MAJSITE',
    'ROLE_FRANCHISE',
    'ROLE_SUCCURSALE'
  ],
  ROLE_SUPER_ADMIN: ['ROLE_ADMIN', 'ROLE_ALLOWED_TO_SWITCH'],
  onlyGuest: []
};

export default authRoles;
